/* eslint-disable camelcase */
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  SystemAlertConfigurationService,
  type Wealthlane_Dtos_SystemAlertConfiguration_SystemAlertConfigurationDto,
} from '../../services/wealthlane-identity-services';

const usePostSystemAlertConfiguration = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeModal: () => void,
  id?: string
): UseMutationResult<
  Wealthlane_Dtos_SystemAlertConfiguration_SystemAlertConfigurationDto | undefined,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      if (id != null && id !== '') {
        return await handleRequest(
          SystemAlertConfigurationService.putApiIdentityApiAppSystemAlertConfiguration(id, payload)
        );
      }
      return await handleRequest(
        SystemAlertConfigurationService.postApiIdentityApiAppSystemAlertConfiguration(payload)
      );
    },
    {
      onSuccess: async (
        response: Wealthlane_Dtos_SystemAlertConfiguration_SystemAlertConfigurationDto | undefined
      ) => {
        if (response != null) {
          await queryClient.invalidateQueries('getSystemAlertConfigurationList');
          closeModal();
          toast.success(
            <ToastComponent
              label='Success'
              message={`Alert Recipient ${id != null && id !== '' ? 'edited.' : 'added.'}`}
            />
          );
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostSystemAlertConfiguration;
